import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import { router } from './router/router';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { growthbook } from './hooks/third-party/growthBook/useGrowthBook';

function App() {
  return (
    <GrowthBookProvider growthbook={growthbook}>
      <ReactQueryDevtools initialIsOpen={false} />

      <RouterProvider router={router} />
    </GrowthBookProvider>
  );
}

export default App;
